// removed by extract-text-webpack-plugin
module.exports = {"Main":"src-containers-Users-__UsersPage-module___Main"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Users/UsersPage.module.css
// module id = 1169
// module chunks = 1